import React, { Component } from 'react';
import { connect } from 'react-redux';
import store from '../../store';

import { fetchGet } from '../../common/common';
import { getPrePostCheckBox, getEditPolicyResults, getCheckBoxDetails, getOldSeat } from '../../actions/editPolicy-actions';
import LineInp from '../common/input';

import EditDetails from '../editDetail/EditDetail';
import OtpTimer from '../otpTimer/OtpTimer';

class PnrDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pnr: window.pnrno,
            OTP: '',
            validateOTP: false,
            getOTP: false,
            mobile: '',
            modificationAPI: false,
            seatEditAPI: false,
            modificationAllow: false,
            seatEditAllow: false,
            errorMsg: '',
            toggleTimer: false,
            resendOtp: false,
        };
    }

    onChange = (e) => {
        const re = /^[0-9 -]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ pnr: e.target.value })
        }
    }

    otpChange = (e) => {
        const re = /^[0-9]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ OTP: e.target.value })
        }
    }

    goBack = (e) => {
        setTimeout(() => { 
            if(window.localStorage.getItem('appPage')){
                window.location.href = '/?gotohome=true';
            }else{
                window.history.back();
            }
        }, 100)
    }

    pnrDetails = () => {
        //console.log("PNR-> ", this.state.pnr);
        return (
            <div>
                <div className='top-wrapper' style={{ background: window.color['searchBoxBgColor'] }}>
                    <span className='back-arrow' onClick={(event) => this.goBack(event)} >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='25px' fill='#fff'>
                            <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z" />
                        </svg>
                    </span>
                    <span className='header-title'>
                        Edit Booking
                    </span>
                </div>
                <div className='ep-wrapper' style={{ zIndex: '2' }}>
                    <div className='info-wrapper'>
                        <div className='info-wrapper-left'>
                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.9993 0.667969C6.63935 0.667969 0.666016 6.6413 0.666016 14.0013C0.666016 21.3613 6.63935 27.3346 13.9993 27.3346C21.3593 27.3346 27.3327 21.3613 27.3327 14.0013C27.3327 6.6413 21.3593 0.667969 13.9993 0.667969ZM15.3327 20.668H12.666V12.668H15.3327V20.668ZM15.3327 10.0013H12.666V7.33463H15.3327V10.0013Z" fill="#01AEF0" />
                            </svg>
                        </div>
                        <div className='info-wrapper-right'>
                            Enter your reservation code (PNR) - (Ticket No.)<br />in the form below. For eg.123456-87654
                        </div>
                    </div>
                    <div className='input-wrapper'>
                        <div>
                            <div className='pnr-input-wrapper'>
                                <LineInp
                                    type='text'
                                    value={this.state.pnr}
                                    placeholder='Enter PNR No'
                                    name='pnr'
                                    style={{ width: '100%' }}
                                    handleChange={this.onChange}
                                    className='input-pnrno'
                                />
                            </div>
                            <div className={`btn-get-otp ${this.state.pnr && this.state.pnr.indexOf('-') > -1 ? "" : "btnDisabled"}`} onClick={() => this.seatEditPolicyDetails()} style={{ background: window.color['buttonColor'] }}>GET OTP</div>
                        </div>
                        {this.state.errorMsg && (<div style={{ fontSize: '12px', fontWeight: '600', marginTop: '16px', color: '#D32F2F' }}>{this.state.errorMsg}</div>)}

                        <div className="notes-wrapper">
                            <span className="notes-wrapper">Please Note</span>
                            <ul>
                                <li>Modification will be allowed only once per user</li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    seatEditPolicyDetails = () => {
        let that = this;

        //let url = '/api/resource/Microsite_ModificationDetailsV1?PNR=' + this.state.pnr;

        //for app webview pass app agentId in api
        const appAgentId = localStorage.getItem("AgentId");
        /*if(appAgentId){
            url+='&appAgentId='+appAgentId;
        } */

        this.setState({ errorMsg: '',modificationAPI: false,seatEditAPI: false,modificationAllow: false,seatEditAllow: false})

       /*  fetchGet(url).then((data) => {
            that.setState({ modificationAllow: true });
            //this.getPNRDetails();
            let modificationResult = JSON.parse(data).APIMicrosite_ModificationDetailsV1Result;
            if (modificationResult.ErrorMessage == '') {
                that.setState({ modificationAPI: true });
                //console.log('aa',modificationResult);
                store.dispatch(getPrePostCheckBox(modificationResult));
            } else {
                console.log(modificationResult.ErrorMessage);
            }

            this.getPNRDetails(); */

            let urlSeatEdit = '/api/resource/GetOnlineSeatEditPolicy?PNR=' + this.state.pnr;
            if(appAgentId){
                urlSeatEdit+='&AgentID='+appAgentId;
            }

            fetchGet(urlSeatEdit).then((data) => {
                that.setState({ seatEditAllow: true });
                //this.getPNRDetails();
                let seatEditResult = JSON.parse(data).APIMicrosite_GetOnlineSeatEditPolicyResult;
                if (seatEditResult.ErrorMessage == '') {
                    that.setState({ seatEditAPI: true });
                    store.dispatch(getCheckBoxDetails(seatEditResult));
                } else {
                    console.log(seatEditResult.ErrorMessage);
                }

                this.getPNRDetails();

            }).catch(function (error) {
                store.dispatch(getCheckBoxDetails(false));
                console.log(error);
            });

        /* }).catch(function (error) {
            store.dispatch(getCheckBoxDetails(false));
            console.log(error);
        }); */
    }

    getPNRDetails = () => {
        //if ((this.state.modificationAllow === true) && (this.state.seatEditAllow === true)) {
        if (this.state.seatEditAllow === true) {
            //if ((this.state.modificationAPI === true) || (this.state.seatEditAPI === true)) {
            if ((this.state.seatEditAPI === true)) {
                let url = '/api/resource/BookingInfo?PNR=' + this.state.pnr;

                 //for app webview pass app agentId in api
                const appAgentId = localStorage.getItem("AgentId");
                if(appAgentId){
                    url+='&appAgentId='+appAgentId;
                }

                fetchGet(url).then((data) => {
                    if (data.Status) {
                        store.dispatch(getEditPolicyResults(data.BookingInfo));
                        store.dispatch(getOldSeat(JSON.parse(JSON.stringify(data.BookingInfo.APIGetBookingDetailsResult[0].PaxDetail))));
                        this.sendOTP();
                    } else {
                        //alert(data.Error);
                        this.setState({ errorMsg: data.Error })
                    }
                }).catch(function (error) {
                    store.dispatch(getEditPolicyResults(false));
                    //alert("somethig went wrong..");
                    console.log(error);
                });
            } else {
                //alert('Seat edit & Prepone-Postpone is not allowed for this pnr');
                //this.setState({ errorMsg: 'Seat edit & Prepone-Postpone is not allowed for this pnr' })
                this.setState({ errorMsg: 'Seat edit is not allowed for this pnr' })
            }
        }
    }

    sendOTP = () => {
        this.setState({ errorMsg: '' });
        let mobile = this.props.editPolicy.data.APIGetBookingDetailsResult[0].PassengerContactNo1;
        let url = '/api/resource/GenerateOTP?mobile=' + mobile + '&otptype=AS';

        //for app webview pass app agentId in api
        const appAgentId = localStorage.getItem("AgentId");
        if(appAgentId){
            url+='&appAgentId='+appAgentId;
        }

        fetchGet(url).then((data) => {
            let bookingDetails = JSON.parse(data).APIAgentOTPResult;
            console.log(bookingDetails);
            //if (bookingDetails === '') {
            this.setState({ getOTP: true, mobile, resendOtp: false });
            this.onTimerStart();
            //} else {
            //console.log(bookingDetails);
            //}
        }).catch(function (error) {
            //alert("somethig went wrong..");
            console.log(error);
        });
    }

    getOTP = () => {
        return (
            <div>
                <div className='top-wrapper' style={{ background: window.color['searchBoxBgColor'] }}>
                    <span className='back-arrow' onClick={() => this.setState({ getOTP: false })} >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='25px' fill='#fff'>
                            <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z" />
                        </svg>
                    </span>
                    <span className='header-title'>
                        Edit Booking
                    </span>
                </div>
                <div className='ep-wrapper' style={{ zIndex: '3' }}>
                    <div className='info-wrapper'>
                        <div className='info-wrapper-left'>
                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.9993 0.667969C6.63935 0.667969 0.666016 6.6413 0.666016 14.0013C0.666016 21.3613 6.63935 27.3346 13.9993 27.3346C21.3593 27.3346 27.3327 21.3613 27.3327 14.0013C27.3327 6.6413 21.3593 0.667969 13.9993 0.667969ZM15.3327 20.668H12.666V12.668H15.3327V20.668ZM15.3327 10.0013H12.666V7.33463H15.3327V10.0013Z" fill="#01AEF0" />
                            </svg>
                        </div>
                        <div className='info-wrapper-right'>
                            Enter the OTP send to your mobile number <br />+91-{this.state.mobile}
                        </div>
                    </div>
                    <div className='input-wrapper'>
                        <div className='pnr-input-wrapper'>
                            <LineInp
                                type='text'
                                value={this.state.pnr}
                                placeholder='Enter PNR No'
                                name='pnr'
                                style={{ width: '100%' }}
                                handleChange={this.onChange}
                                className='input-pnrno'
                            />
                        </div>
                        <div className='otp-input-wrapper'>
                            <LineInp
                                type='text'
                                value={this.state.OTP}
                                placeholder='Enter OTP'
                                name='otp'
                                style={{ width: '100%' }}
                                handleChange={this.otpChange}
                                className='input-otp'
                            />
                        </div>
                        {this.state.errorMsg && (<div style={{ fontSize: '12px', fontWeight: '600', marginTop: '-5px', marginBottom: '5px', color: '#D32F2F' }}>{this.state.errorMsg}</div>)}
                        <div className='action-button-wrapper'>
                            <div className={`action-button-left ${!this.state.resendOtp ? 'btnDisabled' : ''}`} onClick={() => this.sendOTP()}>RESEND OTP</div>
                            <div className={`action-button-right ${this.state.OTP.length === 4 ? "" : "btnDisabled"}`} onClick={() => this.validateOTP()}>PROCEED</div>
                        </div>
                        <div className="otp-timer-wrapper">You can resend the OTP {this.state.resendOtp ? 'now' : 'in'}{' '}{this.state.toggleTimer && <OtpTimer timerFor={3} onTimerClose={this.onTimerClose} />}</div>
                        <div className="notes-wrapper">
                            <span className="notes-wrapper">Please Note</span>
                            <ul>
                                <li>You can utilize the previous OTP you received at least 15 minutes ago on your registered mobile number</li>
                                <li>Request a new OTP once the resend option is activated</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    closeSlider = (name, value) => {
        this.setState({ [name]: value });
    }

    validateOTP = () => {
        this.setState({ errorMsg: '' });
        let mobile = this.props.editPolicy.data.APIGetBookingDetailsResult[0].PassengerContactNo1;
        let url = '/api/resource/APIValidateAgentOTP?OTP=' + this.state.OTP + '&otptype=AS&mobile='+mobile;

        //for app webview pass app agentId in api
        const appAgentId = localStorage.getItem("AgentId");
        if(appAgentId){
            url+='&appAgentId='+appAgentId;
        }

        fetchGet(url).then((data) => {
            let validateData = JSON.parse(data).APIValidateAgentOTPResult;
            if (validateData === '') {
                this.setState({ validateOTP: true })
            } else {
                this.setState({ errorMsg: validateData })
            }
        }).catch(function (error) {
            console.log(error);
        });
    }

    onTimerStart = () => {
        this.setState({ toggleTimer: true });
    }

    onTimerClose = () => {
        this.setState({ toggleTimer: false, resendOtp: true });
    }

    render() {
        return (
            <div>
                {this.pnrDetails()}
                {this.state.getOTP && this.getOTP()}
                {this.state.validateOTP && <EditDetails closeSlider={(a, b) => this.closeSlider(a, b)} />}
            </div>
        );
    }
}

const mapStateToProps = function (store) {
    return (store);
};

export default connect(mapStateToProps)(PnrDetail);


// WEBPACK FOOTER //
// ./src/components/pnrDetail/pnrDetail.js